export default function getImageLink(image: string) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const viteCdnHost = import.meta.env.VITE_CDN_HOST as string;
  return viteCdnHost + '/' + image;
}
